import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CdkStep } from '@angular/cdk/stepper';

@Component({
  exportAs: 'seechStep',
  selector: 'seech-step',
  standalone: true,
  imports: [CommonModule],
  template: '<ng-template><ng-content></ng-content></ng-template>',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkStep, useExisting: StepComponent }],
})
export class StepComponent extends CdkStep {
  private _disabled = false;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  
  set disabled(value: boolean) {
    this._disabled = value;
  }
}
